import { getItemFromWebStorage, setItemOnWebStorage } from '@ynap/web-storage-utils';
import { v4 as uuid } from 'uuid';

// Hack clean up whitelisted visitorId added to localstorage by optimizely web experiments
const nonUniqueIds = ['mmmON', 'mmmOFF', 'toggleTaxes', 'hiddenTaxes', 'default', 'random', 'impulse', 'trending', 'ssrKey', 'withSortBy', 'withoutSortBy'];

export const getVisitorId = () => {
    if (typeof window !== 'undefined') {
        const visitorKey = 'opt_fs_visitorId';
        let id = getItemFromWebStorage('localStorage', visitorKey);

        if (!id || nonUniqueIds.includes(id)) {
            id = uuid();
            setItemOnWebStorage('localStorage', visitorKey, id);
        }

        return id;
    }
};

export const getExperimentDecision = (optimizely, experiments) => {
    const enabledExperiment = experiments.find((feature) => optimizely?.isFeatureEnabled?.(feature));

    return optimizely?.userContext?.decide(enabledExperiment || '') || {};
};
